// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21iMB","title":"Header_title__2Wu3D","left":"Header_left__6K5w3","clinicName":"Header_clinicName__3IPvS"};